import routes from "routes";

export const useRouteName = () => {
  let name = "";
  const userRoute = "/user";
  routes.forEach((route) => {
    if (window.location.href.indexOf(userRoute + route.path) !== -1) {
      name = routes.rtlActive ? route.rtlName : route.name;
    }
  });
  return name;
};
